<template>
    <div class="flex flex-col gap-3">
        <div v-for="i in count" :key="i" class="rounded-2xl border border-[#e2e8f0] bg-white px-5 py-4 shadow-[4px_4px_10px_0px_rgba(0,0,0,0.1)]">
            <div class="flex items-center gap-4">
                <!-- Title placeholder -->
                <div class="h-4 flex-1 animate-pulse rounded bg-gray-200" :style="{ maxWidth: `${titleWidths[i - 1]}%` }" />
                <!-- Badge placeholder -->
                <div class="h-5 w-20 shrink-0 animate-pulse rounded-full bg-gray-200" />
                <!-- Icon placeholders -->
                <div class="h-5 w-4 shrink-0 animate-pulse rounded bg-gray-200" />
                <div class="h-5 w-4 shrink-0 animate-pulse rounded bg-gray-200" />
            </div>
        </div>
    </div>
</template>

<script setup lang="ts">
const { count = 3 } = defineProps<{ count?: number }>();

const titleWidths = [55, 70, 45, 60, 50];
</script>
